import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router } from "react-router-dom";
import App from './App';
import { initAnalytics } from './analytics';
import './index.css';

// Versiones anteriores del sitio registraban un service worker que cachea index.html;
// sin esto los navegadores que lo tienen siguen sirviendo la versión vieja indefinidamente.
if ('serviceWorker' in navigator) {
  navigator.serviceWorker.getRegistrations()
    .then(registrations => registrations.forEach(registration => registration.unregister()))
    .catch(() => {});
}

initAnalytics();

ReactDOM.render(
  <Router>
    <App />
  </Router>,
  document.getElementById("root")
);



// WEBPACK FOOTER //
// ./src/index.js